import React, { useEffect } from 'react';
import './about.css';
import Languages from './Languages';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import { FaStar, FaMoon, FaSun, FaBook, FaPhoneAlt, FaHandshake } from 'react-icons/fa';

import SUGUMARSWAMY from '../images/DSUGUMARSWAMY.jpg';
export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>
      {/* <Topbar /> */}
      <Navbar />












  <section id="profile-section">
  <div class="content-wrapper">
    <div class="profile-content">
      <h2>Our Chief Nadi Astro Reader</h2>
      <p>
      Our Chief Nadi Astrologer Mr  D. Sugumar Swamy is a famous Nadi Astrologer in Hyderabad, India.   He specializes in Nadi Jyotish, Palm Leaf Reading, Astrology and Vaitheeswaran Temple.   We can be proud to say that this center is the oldest nadi astrology center in India. We are now in the 4th generation of Nadi Astrology service to the blessed people all over the world carrying this service from our forefathers.The science of nadi astrology is one of the most accurate ways of predicting an individual's future.   It has benefited thousands of people all over the world and given them great guidance in their life decisions. Every human being's future expectation is contributed through palm leaves and has been studied by four generations of our family. This applies to all countries of the world. Using the latest knowledge through internet, we are now bringing our service online for the benefit of people all over the world.
      You can book our Nadi Astrologer online now. 
      </p>
      <ul>
        <li>Expert in ancient palm-leaf readings.</li>
        <li>Renowned for precise predictions and remedies.</li>
        <li>Guided thousands to clarity and success.</li>
      </ul>
      <p>
        His unique ability to connect ancient wisdom with modern insights makes him one
        of the most sought-after astrologists in the field.
      </p>
    </div>
    <div class="profile-photo">
      <div class="photo-wrapper">
      <img src={SUGUMARSWAMY} alt="Palm Leaf Readings" className="card-img-top" />
      <h5>Mr  D. Sugumar Swamy</h5>
      <p>Chief Nadi Astrologist</p>

      </div>
    </div>
  </div>
</section>











      <div className="about-container">
       

        {/* About Section */}
        <section className="about-details">
          <h2>About Us</h2>
          <p>At Shiva Nadi Astrology, we offer insights into the past, present, and future through ancient astrological techniques. Our expert astrologers are dedicated to helping you understand your life path, guide you through challenges, and reveal the hidden truths of your soul’s journey.</p>
          <p>We specialize in Nadi astrology, an ancient and mystical form of astrology that originated in India, where palm leaves hold the answers to your destiny. We are committed to helping you find clarity, peace, and purpose in life with personalized readings.</p>
        </section>

        {/* Services Section */}
        <section className="services-section">
          {/* <h2>Our Expertise</h2> */}
          <div className="services-cards">
            {/* <div className="service-card">
              <FaStar className="service-icon" />
              <h3>Horoscope Readings</h3>
              <p>Explore your birth chart and uncover insights about your life's journey. Our astrological readings offer guidance for personal growth, relationships, and career paths.</p>
            </div> */}
            {/* <div className="service-card">
              <FaMoon className="service-icon" />
              <h3>Lunar Astrology</h3>
              <p>Understand the impact of lunar cycles on your life. Our lunar astrology services help you harness the power of the moon for better decision-making and spiritual alignment.</p>
            </div> */}
            {/* <div className="service-card">
              <FaSun className="service-icon" />
              <h3>Solar Analysis</h3>
              <p>Gain a deeper understanding of your solar influences and how they affect your personality, relationships, and life purpose. We provide detailed solar analysis tailored to your needs.</p>
            </div> */}
            {/* <div className="service-card">
              <FaBook className="service-icon" />
              <h3>Nadi Readings</h3>
              <p>Discover the ancient wisdom of Nadi astrology through personalized readings based on sacred palm leaves. Our experts interpret these ancient manuscripts to reveal your life’s true path.</p>
            </div> */}
          </div>
        </section>



        <section className="services-section">

        <h2>Our Expertise</h2>
        <div className="services-cards">

              <div className='container'>

                <div className='row'>

<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

  
<FaBook className="service-icon" />
              <h3>Nadi Readings</h3>
              <p>Discover the ancient wisdom of Nadi astrology through personalized readings based on sacred palm leaves. Our experts interpret these ancient manuscripts to reveal your life’s true path.</p>


</div>

                </div>
              </div>


        </div>
        </section>

        {/* Mission Section */}
        <section className="mission-section">
          <h2>Our Mission</h2>
          <p id="para">At Shiva Nadi Astrology, our mission is to empower individuals by providing them with deep astrological insights that illuminate their life's journey. We aim to bring clarity, peace, and spiritual growth through the ancient practices of astrology.</p>
          <div className="mission-points">
            <div>
              <FaHandshake className="mission-icon" />
              <p>Fostering a deeper connection between individuals and the universe through trust and guidance.</p>
            </div>
            <div>
              <FaStar className="mission-icon" />
              <p>Helping you discover your life's purpose and navigate through life's challenges with confidence.</p>
            </div>
          </div>
        </section>

       
      </div>
      <Footer />
    </>
  );
}
